<template>
  <div id="modal_voting">
    <div class="header_modal fs_big tal_c">
      {{ $t("msg.terms_and_conditions") }}
    </div>
    <div class="body_modal">
      <div class="container-text" v-on:scroll="mapScroll" v-if="!screenMobile">
        <!-- <iframe
          scrolling="no"
          class="pdf-container"
          style="pointer-events: none;"
          :src="'/Terms_and_Conditions_en.pdf'"
          frameborder="0"
          type="application/pdf"
        ></iframe> -->

        <embed
          :src="'/BLUE_T_C_MAY2022.pdf'"
          v-on:scroll="mapScroll"
          class="pdf-container"
          type="application/pdf"
        />
      </div>
      <div class="tal_c" v-if="screenMobile">
        <a
          href="/BLUE_T_C_MAY2022.pdf"
          v-html="$t('msg.terms_and_conditions')"
          target="_blank"
        ></a>
      </div>
      <div class="column tal_c fs_small" v-if="!screenMobile">
        <a href="/BLUE_T_C_MAY2022.pdf" target="_blank" @click="docIsOpened()"
          ><span v-html="$t('msg.download_pdf')"></span
        ></a>
        <span v-html="$t('msg.you_must_accpet_terms')" for="checkTerms"></span>
      </div>
      <div
        class="column tal_c"
        :class="handleScroll || docOpened ? 'pointer' : 'block-box'"
        v-if="!screenMobile"
      >
        <input type="checkbox" v-model="checkTerms" name="checkTerms" />
        <span v-html="$t('msg.i_read')" for="checkTerms"></span>
      </div>
      <div class="column tal_c" v-if="screenMobile">
        <input type="checkbox" v-model="checkTerms" name="checkTerms" />
        <span v-html="$t('msg.i_read')" for="checkTerms"></span>
      </div>
      <div class="column tal_c red_color fs_00r" v-if="!screenMobile">
        <span v-html="$t('msg.browser_message')" for="checkTerms"></span>
      </div>
      <div class="column tal_c" v-if="!loading">
        <button
          class="button-slips fat"
          @click="callNext()"
          :disabled="!checkTerms"
        >
          {{ $t("msg.confirmed") }}
        </button>
      </div>

      <div class="column" style="display:flex; justify-content:center" v-else>
        <button class="button-slips fat m13_t">
          <Loading />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from "../public/Loading";
export default {
  created() {
    this.checkScreen();
  },
  data: () => ({
    checkTerms: false,
    handleScroll: "",
    batata: "",
    screenMobile: "",
    docOpened: false,
    loading: false,
  }),
  methods: {
    callNext() {
      this.loading = true;
      try {
        this.$store.dispatch("putAcceptTerms");
        setTimeout(() => {
          this.$emit("closeModal");
        }, 1000);
      } catch (e) {
        console.log(e);
      }
    },

    docIsOpened() {
      this.docOpened = true;
    },

    checkScreen() {
      let screen = window.innerWidth;

      if (screen < 800) {
        this.screenMobile = true;
      } else {
        this.screenMobile = false;
      }
    },

    mapScroll() {
      var contTerms = document.getElementsByClassName("pdf-container");
      let scrollTop = contTerms[0].scrollTop;
      let contSize = contTerms[0].scrollHeight - 2 - contTerms[0].clientHeight;

      if (scrollTop >= contSize) {
        this.handleScroll = true;
      } else {
        this.handleScroll = false;
      }
    },
  },
  components: {
    Loading,
  },
  computed: {},
};
</script>
<style lang="scss" scope>
#modal_voting {
  background-color: #ffffff;
  margin-top: 5vh;
  width: 100%;
  max-width: 1100px;
  min-height: 80%;
  display: block;
  margin-left: auto;
  margin-right: auto;
  border-radius: 7px;
  word-wrap: break-word;
  font-size: 20px;
  font-size: 1.2em;

  .button-slips {
    background-color: #1e2067;
    padding: 10px 30px;
    font-size: 15px;
    color: white;
    border: none;
    border-radius: 10px;
    margin-top: 20px;
    cursor: pointer;
    &:active {
      background-color: #6146ad;
    }
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  .block-box {
    opacity: 0.5;
    pointer-events: none;
  }

  .coins_cont {
    box-shadow: 0px 2px 4px #041a381a;
    margin-right: 10px;
    border-radius: 21px;
    border: 2px solid transparent;
    margin-bottom: 10px;
    cursor: pointer;
    &:last-child {
      margin-right: 0px;
    }

    &:active {
      background: #8a65f1;
    }
  }

  .selected_coin {
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 40px #041a384d;
    border: 2px solid #c9d1ff;
    border-radius: 21px;
    opacity: 1;
  }

  .coin_info {
    background: #f3f3f3;
    border-radius: 3px;
    min-height: 76.95px;
  }

  .actived_info {
    background-color: #c5c0c0;
  }

  .icon_class_symbol {
    svg {
      width: 40px;
      height: 40px;
    }
  }

  .cont_name {
    min-height: 82px;
  }

  .green {
    color: #00b593;
  }

  .red_color {
    color: #db1f43;
  }

  .header_modal {
    background: #0966aa;
    color: white;
    min-height: 55px;
    border-radius: 7px 7px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .body_modal {
    padding: 20px 60px;

    .container-text {
      border: solid 1px black;
      max-height: 650px;
      overflow: scroll;
      .pdf-container {
        height: 850px;
        width: 100%;
        overflow: hidden;
      }
    }
  }

  .content_info {
    border-left: solid 1px #d0d4d9;
    font-size: 13px;
    &:first-child {
      border-left: none;
    }
  }

  .text_info {
    font-weight: 100;
    color: #707070;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/modalTermsConditions.vue